import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Header from '../../components/Common/Header/Header';
import ContentApp from '../../components/ContentApp';
import SimpleNetworkStats from '../../components/Network/SimpleNetworkStats';
import BoxShareLink from '../../components/BoxShareLink/BoxShareLink';
import { WelletContext } from '../../context/WelletContext';
import { CircleSpinner } from 'react-spinners-kit';
import { formatMoney } from '../../helpers/format';

const MySimpleNetwork = () => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const app = useSelector((state) => state.app);
  const user = useSelector((state) => state.associates.user);
  const [loading, setLoading] = useState(true);
  const currency = useSelector((state) => state.currency.default);
  const items = t('myNetworkScreen.howItWorksItems', { returnObjects: true });
  const examples = t('myNetworkScreen.howItWorksExamples', { returnObjects: true });

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: app.name,
          url: user.homeSiteUrl,
        });
      } else {
        console.warn('Web Share API not supported in this browser.');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  const getCommissions = async () => {
    setLoading(true);
    try {
      const response = await welletContext.apis.tickets.get(`associates/commission`);
      if (response.status === 200) {
        // setEarnNetworkPerPax(
        //   response.data.sellerGoals.find((goal) => goal.prizePaymentType === 'AMOUNT_PER_PAX'),
        // );
      } else {
        console.error('Failed to fetch data', response);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCommissions();
  }, []);

  return (
    <>
      <Header />
      {loading ? (
        <div className='loading-app' style={{ zIndex: 1000 }}>
          <div className='loaderDiv'>
            <CircleSpinner
              className='spinner-app mx-auto'
              style={{ margin: 'auto' }}
              size={40}
              color='var(--color-font-primary)'
            />
          </div>
        </div>
      ) : (
        <ContentApp>
          <div className='font-125 fw-700 text-tertiary'>{t('myNetworkScreen.title')}</div>
          <div className='card bg-primary font-extra-small text-center text-black fw-700 py-1 mt-3'>
            {t('myNetworkScreen.FIRST_SALE_SELLER_description')}
          </div>
          <p
            className='text-small text-tertiary mt-2'
            dangerouslySetInnerHTML={{
              __html: t('myNetworkScreen.prizeDescription'),
            }}
          />

          <div className='text-primary fw-700 font-tiny mt-4'>{t('hereIsYourLink')}</div>
          <div className='mt-2'>
            <BoxShareLink
              link={user.homeSiteUrl}
              shareButtonText={t('share')}
              onShareClick={handleShare}
            />
          </div>

          <div className='card font-small text-tertiary p-3 mt-4'>
            <div className='fw-700'>{t('myNetworkScreen.howItWorks')}</div>
            <ul className='fw-500 list-none mt-3 pl-3'>
              {items.map((item, index) => (
                <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </ul>
          </div>

          <div className='card font-small text-tertiary p-3 mt-2'>
            <div className='fw-700'>{t('example')}</div>
            <div className='fw-500 list-none mt-2 pl-1'>
              {examples.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </div>
          </div>

          <div className='mt-5'>
            <SimpleNetworkStats />
          </div>
        </ContentApp>
      )}
    </>
  );
};

export default MySimpleNetwork;
